/**
 * Utility functions for URL handling
 */

/**
 * Joins a base URL and a path, ensuring there's exactly one slash between them.
 *
 * @param baseUrl The base URL (e.g., "https://example.com")
 * @param path The path to append (e.g., "/api/reports")
 * @returns The joined URL with exactly one slash between base and path
 */
export const joinUrl = (baseUrl: string, path: string): string => {
  // Remove trailing slash from base URL if it exists
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl

  // Ensure path starts with a slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`

  return `${cleanBaseUrl}${cleanPath}`
}
